import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const treasureBoxSettingsSlice = createSlice({
    name: "treasureBoxSettings",
    initialState: {
        success: false,
        fail: false,
        playCountInfo: null,
        responseData: null,
        errorDetailData: null,
    },
    reducers: {
        doGetPlayCountInfoSuccess: (state, action) => {
            state.playCountInfo = action.payload.data;
        },
        doGetPlayCountInfoFail: (state, action) => {
            state.playCountInfo = null;
        },
        doUpdateCycleLengthSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
            state.responseData = action.payload;
        },
        doUpdateCycleLengthFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        resetStateSuccess: (state, action) => {
            state.success = false;
            state.fail = false;
            state.errorDetailData = null;
        },
    },
});

/**
 * Get current play count information
 */
export const doGetPlayCountInfo = () => async (dispatch) => {
    try {
        const url = `/api/admin/system-settings/play-count-info`;
        const response = await axios.get(url);
        dispatch(doGetPlayCountInfoSuccess(response.data));
    } catch (error) {
        dispatch(doGetPlayCountInfoFail(error.response));
    }
};

/**
 * Update cycle length
 */
export const doUpdateCycleLength = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/system-settings/cycle-length`;
        const response = await axios.put(url, param);
        dispatch(doUpdateCycleLengthSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateCycleLengthFail(error.response));
    }
};

/**
 * Update credits per treasure point
 */
export const doUpdateCreditsPerTreasurePoint = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/system-settings/credits-per-treasure-point`;
        const response = await axios.put(url, param);
        dispatch(doUpdateCycleLengthSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateCycleLengthFail(error.response));
    }
};

/**
 * Reset state
 */
export const resetState = () => async (dispatch) => {
    dispatch(resetStateSuccess(false));
};

// Export actions
export const {
    doGetPlayCountInfoSuccess,
    doGetPlayCountInfoFail,
    doUpdateCycleLengthSuccess,
    doUpdateCycleLengthFail,
    resetStateSuccess,
} = treasureBoxSettingsSlice.actions;

// Selectors
export const getPlayCountInfo = (state) => state.treasureBoxSettings?.playCountInfo;
export const getSuccess = (state) => state.treasureBoxSettings?.success;
export const getFail = (state) => state.treasureBoxSettings?.fail;
export const getErrorData = (state) => state.treasureBoxSettings?.errorDetailData;

export default treasureBoxSettingsSlice.reducer;
